import CustomIcon from "./CustomIcon";
import CustomButton from "./CustomButton";


const EmptyState = ({title = false, message, icon, hasButton = false, buttonLabel, onClick, isSmall= false, hasBackground=false}) => {
  return <div className={`${isSmall ? "py-2" : "py-24"} w-full  px-6  flex flex-col justify-center items-center rounded-md text-center${hasBackground ? " bg-secondary-100" : ""}`}>

    <div className={`${isSmall ? "w-14 h-14" : "w-24 h-24"} rounded-full bg-blue-100 flex justify-center items-center my-4`}>
      <CustomIcon icon={icon ? icon : "folder_open"} className="text-blue-300" size={isSmall ? "3xl" : "3xl"}/>
    </div>
    {title && <div className="text-lg font-bold mb-1">{title}</div>}
    <div className="text-base mb-4">{message ? message : "No data available."}</div>
    {hasButton &&
    <CustomButton className="px-8" onClick={onClick}>
      {buttonLabel ? buttonLabel : "Add"}
    </CustomButton>}
  </div>
}


export default EmptyState